module.exports = __webpack_public_path__ + "static/media/clone.a68cea6d.svg";